import React from 'react';
import {useGlobalState} from "../../../GlobalState";
import {usePWA} from "../../../Pwa";

import {Nav} from "./Nav";
import {pages} from "./pages";
import {alpha, styled, Avatar, Box, ButtonBase, Divider, Drawer, Typography} from '@mui/material';
import {deepOrange} from '@mui/material/colors';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import LaptopIcon from '@mui/icons-material/Laptop';
import LogoutIcon from '@mui/icons-material/Logout';

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Sidebar = props => {
        const {open, isDesktop, onPageSelect, onClose, onLogout} = props;
        const {userData} = useGlobalState();
        const {isPWAInstallable, installPWA} = usePWA();
        const {user} = userData;

        const userName = `${user.name} ${user.surname}`;
        const email = user.email;
        const initialLetters = `${user.name.charAt(0)}${user.surname.charAt(0)}`;

        const InstallIcon = isDesktop ? LaptopIcon : PhoneAndroidIcon;

        return (
            <Drawer
                anchor="left"
                PaperProps={{sx: {width: (theme) => theme.custom.sidebar.width}}}
                onClose={onClose}
                open={open}
                variant={isDesktop ? 'persistent' : 'temporary'}>

                <DrawerHeader>
                    <Box component="img" alt="LivignoItaly logo" src="/img/logo_b1_300.png" sx={{width: "100%", px: 3, py: 1}}/>
                </DrawerHeader>

                <Box sx={{flexGrow: 1, p: 2, pb: 4}}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minHeight: 'fit-content',
                        pt: 2,
                        pb: 4
                    }}>
                        <Avatar alt={user.name}
                                src={user.avatar}
                                sx={{
                                    width: 80,
                                    height: 80,
                                    color: 'white',
                                    backgroundColor: deepOrange[500],
                                    mb: 2
                                }}>
                            {initialLetters}
                        </Avatar>
                        <Typography variant="h6">
                            {userName}
                        </Typography>
                        <Typography color="textSecondary">
                            <Box component="span" sx={{fontSize: "0.75rem"}}>
                                {email}
                            </Box>
                        </Typography>
                    </Box>

                    <Nav pages={pages} onPageSelect={onPageSelect}/>
                </Box>

                {
                    isPWAInstallable &&
                    <ButtonBase
                        onClick={installPWA}
                        sx={{
                            m: 2,
                            p: 1,
                            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                            borderRadius: 1,
                            color: 'primary.main',
                            textTransform: 'uppercase'
                        }}>
                        <InstallIcon sx={{fontSize: 24, mr: 1}}/>
                        <Typography variant="subtitle2">
                            Installa
                        </Typography>
                    </ButtonBase>
                }

                <Box sx={{color: 'text.primary', fontSize: 9, my: 0.5, textAlign: "center"}}>
                    LivignoItaly - v{process.env.REACT_APP_VERSION}
                </Box>

                <Divider/>

                <List>
                    <ListItem disablePadding>
                        <ListItemButton onClick={onLogout}>
                            <ListItemIcon>
                                <LogoutIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Esci"/>
                        </ListItemButton>
                    </ListItem>
                </List>
            </Drawer>
        );
    }
;

export {Sidebar}